@if (classRoom) {
  <div class="ontario-row">
    <h1 class="page-title">{{'CreateClassroom.TrainingClassroom' | translate}}</h1>
    <div class="classroom-banner ontario-column ontario-small-12 ontario-medium-12 ontario-large-12">
      <label class="program-name">
        {{currentLang =='en' ? classRoom.TrainingProgram?.Name : classRoom.TrainingProgram?.NameFr}}
      </label>
      <label class="training-program-id">{{classRoom.ProgramDisplayId}}</label>
    </div>
    <div class="ontario-column ontario-small-12 ontario-margin-top-16-! published-success-banner-panel">
      @if (isEditSucceed) {
        <div class="classroom-updated-banner">
          <app-alert-banner bannerType="success" [bannerText]="translateService.instant('EditClassRoomUpdated.ClassroomUpdatedBanner').replace('{0}',bannerProgram) + (classRoom.PublishToPublic? translateService.instant('EditClassRoomUpdated.ClassroomUpdatedBannerLink') : '')"></app-alert-banner>
        </div>
      }
      @if (isEditSucceed && bannerDate !='') {
        <div class="classroom-schedule-updated">
          <app-alert-banner bannerType="success" [bannerText]="translateService.instant(classRoom.PublishToPublic? 'EditClassRoomUpdated.PublicClassroomScheduleUpdatedBanner': 'EditClassRoomUpdated.ClassroomScheduleUpdatedBanner').replace('{0}',bannerProgram).replace('{1}',datePipe.transform(bannerDate, 'MMM dd, yyyy'))"></app-alert-banner>
        </div>
      }
      @if (isUpdate && !isConfirmed) {
        <div class="classroom-schedule-updated">
          <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.EnrolmentRequestUpdated' | translate"></app-alert-banner>
        </div>
      }
      @if (isUpdate && isConfirmed) {
        <div class="classroom-schedule-updated">
          <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.EnrolmentRequestUpdatedEnrolled' | translate"></app-alert-banner>
        </div>
      }
      @if (isApiClass) {
        <div class="classroom-schedule-updated">
          <app-alert-banner bannerType="alert" [bannerText]="'ClassEnrolment.ApiClassBanner' | translate"></app-alert-banner>
        </div>
      }
      @if (bannerText) {
        <div class="success-banner">
          <app-alert-banner [bannerType]="bannerType" [bannerText]="bannerText"></app-alert-banner>
        </div>
      }
    </div>
    <div class="ontario-column ontario-small-12  ontario-margin-top-16-! ontario-padding-left-0-! ontario-padding-right-0-!">
      <app-tabs #tabs (click)="checkIfPendingEnroledTabSelected()">
        <app-tab [title]="'Sidebar.Schedule' | translate">
          @if (enrolmentsCompleted) {
            @if (classRoom) {
              <div class="ontario-row ontario-margin-bottom-24-! grey-box numbers-container-width">
                <div class="numbers-container">
                  <div class="ontario-column ontario-50-percent center-aligned right-border">
                    <div class="number-title">
                      {{'CreateClassroom.TotalSeats' | translate}}
                    </div>
                    <div class="number-content">
                      {{classRoom.TotalSeats}}
                    </div>
                  </div>
                  <div class="ontario-column ontario-50-percent center-aligned right-border">
                    <div class="number-title">
                      {{'CreateClassroom.SuccessfulCompletion' | translate}}
                    </div>
                    <div class="number-content">
                      {{totalCompletedLearnerCount}}
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="ontario-row classroom-updated-banner ontario-70-percent">
              <app-alert-banner bannerType="success" [bannerText]="translateService.instant('EditClassRoomUpdated.TrainingSuccessfullyDelivered').replace('{0}',currentLang == 'en' ? classRoom.TrainingProgram?.Name : classRoom.TrainingProgram?.NameFr)">
              </app-alert-banner>
            </div>
          }
          @if (classRoom) {
            <div class="ontario-small-12 ontario-large-6 view-training-schedule-div">
              <div>
                <h4 class="border-bottom ontario-margin-top-16-!">
                  {{'CreateClassroom.TrainingProgramDetails' | translate}}
                </h4>
              </div>
              <div class="content">
                <div class="field ontario-small-12 ontario-large-12">
                  <label>{{'CreateClassroom.SelectProgram' | translate}}</label>
                  <label class="answer-text">
                    {{currentLang == 'en' ? classRoom.TrainingProgram?.Name : classRoom.TrainingProgram?.NameFr}}
                  </label>
                </div>
                <div class="field">
                  <label for="trainingType" class="required-field">
                    {{'Marketplace.TrainingType' | translate}}
                  </label>
                  <label class="answer-text">
                    {{currentLang == 'en' ? classRoom.TrainingType?.Name : classRoom.TrainingType?.NameFr}}
                  </label>
                </div>
                <div class="field">
                  <label for="language" class="required-field">
                    {{'SafetyAndPrevention.Language' | translate}}
                  </label>
                  <label class="answer-text">
                    {{(!classRoom.IsFrench ? 'SafetyAndPrevention.English' : 'SafetyAndPrevention.French') | translate}}
                  </label>
                </div>
                <div class="field">
                  <label for="programId" class="required-field">
                    {{'ProgramDetails.ProgramId' | translate}}
                  </label>
                  <label class="answer-text">{{classRoom.ProgramDisplayId}}</label>
                </div>
              </div>
              @if (!hideSelectDays) {
                <div>
                  <h4 class="border-bottom">{{'CreateClassroom.TrainingDateandTime' | translate}}</h4>
                </div>
              }
              @for (classTime of classRoom.ClassTimes; track classTime; let i = $index) {
                <div class="content">
                  @if (classRoom.ClassTimes.length > 1) {
                    <label class="day-label" [class.dashed]="i > 0"
                    >{{'CreateClassroom.Day' | translate}} {{i + 1}}</label>
                  }
                  <div class="field">
                    <label for="startDate" class="required-field">
                      {{'OnboardingSummary.Date' | translate}}
                    </label>
                    <label class="answer-text">{{classTime.ClassDate | date}}</label>
                  </div>
                  <div class="field">
                    <ng-container>
                      <div class="inline-block ontario-margin-right-24-!">
                        <label class="required-field">{{'CreateClassroom.FromTime' | translate}}</label>
                        <label class="answer-text">{{ getLocalTimeString(classTime.ClassDate.toString()) }}</label>
                      </div>
                      <div class="inline-block">
                        <label class="required-field">{{'CreateClassroom.ToTime' | translate}}</label>
                        <label class="answer-text">{{ getLocalTimeString(classTime.EndDate!.toString())}}</label>
                      </div>
                    </ng-container>
                  </div>
                </div>
              }
              @if (showBlendedSection()) {
                <div class="ontario-column ontario-small-12 ontario-margin-top-16-! combined"
                  >
                  <h5 class="self-paced-label border-top">
                    {{'CreateClassroom.SelfPacedOnlineModule' | translate}}
                  </h5>
                  <label class="form-label ontario-margin-top-24-!">
                    {{'CreateClassroom.ScheduleType' | translate}}
                  </label>
                  <div class="display-only-div">{{'CreateClassroom.Online' | translate}}</div>
                  <label class="form-label ontario-margin-top-24-!">
                    {{'Marketplace.TrainingType' | translate}}
                  </label>
                  <div class="display-only-div">{{'CreateClassroom.SelfPaced' | translate}}</div>
                  <label class="form-label ontario-margin-top-24-!">
                    {{'CreateClassroom.CompletedBeforeTheInPersonSession' | translate}}
                  </label>
                  <div class="display-only-div">{{getSelectedCompletedBeforeOption()}}</div>
                  <div class="display-only-div ontario-margin-bottom-48-!">
                    {{getCompletedBeforeDate()}}
                  </div>
                </div>
              }
              @if (!hideSelectDays && classRoom.TrainingType?.Name === 'Distance learning') {
                <div>
                  <h4 class="border-bottom">{{'CreateClassroom.DistanceTrainingDetails' | translate}}</h4>
                </div>
              }
              @if (!hideSelectDays && classRoom.TrainingType?.Name === 'Distance learning') {
                <div class="content">
                  <div class="field ontario-small-12 ontario-large-6">
                    <label>{{'CreateClassroom.DistanceTrainingDetails' | translate}}</label>
                    <label class="answer-text margin-bottom-0">
                      {{classRoom.DistanceTrainingDetails | naIfEmpty}}
                    </label>
                  </div>
                  <div class="field ontario-small-12 ontario-large-6">
                    <label>{{'CreateClassroom.LinkURLToJoinOnlineMeeting' | translate}}</label>
                    <label class="answer-text">
                      {{classRoom.DistanceTrainingUrl! |naIfEmpty}}
                    </label>
                  </div>
                </div>
              }
              @if (!hideSelectDays) {
                <div>
                  <h4 class="border-bottom">{{'CreateClassroom.TrainingLocation' | translate}}</h4>
                </div>
              }
              @if (!hideSelectDays && !classRoom.AddressLine) {
                <div class="content">
                  <label class="answer-text">N/A</label>
                </div>
              }
              @if (!hideSelectDays && classRoom.AddressLine) {
                <div class="content">
                  <div class="field ontario-small-12 ontario-large-6">
                    <label class="required-field">{{'Address.StreetAddress' | translate}}</label>
                    <label class="answer-text margin-bottom-0">
                      @if (classRoom.AptSuiteUnit) {
                        <span>{{classRoom.AptSuiteUnit}} - </span>
                        }{{classRoom.AddressLine}}
                      </label>
                    </div>
                    <div class="field ontario-small-12 ontario-large-6">
                      <label class="required-field">{{'Address.CityTown' | translate}}</label>
                      <label class="answer-text">{{classRoom.CityTown}}</label>
                    </div>
                    <div class="field ontario-small-12 ontario-large-6">
                      <label class="required-field">{{'Address.Province' | translate}}</label>
                      <label class="answer-text">{{classRoom.Province}}</label>
                    </div>
                    <div class="field ontario-small-12 ontario-large-6">
                      <label class="required-field">{{'Address.PostalCode' | translate}}</label>
                      <label class="answer-text">{{classRoom.PostalCode | postalCode}}</label>
                    </div>
                  </div>
                }
                @if (hideSelectDays) {
                  <div>
                    <h4 class="border-bottom">{{'Marketplace.TrainingType' | translate}}</h4>
                    <div class="ontario-column ontario-small-12 ontario-margin-top-16-!">
                      <h5 class="self-paced-label">{{'CreateClassroom.SelfPacedOnlineModule' | translate}}</h5>
                      <label class="form-label ontario-margin-top-24-!">
                        {{'CreateClassroom.ScheduleType' | translate}}
                      </label>
                      <div class="display-only-div">{{'CreateClassroom.Online' | translate}}</div>
                      <label class="form-label ontario-margin-top-24-!">
                        {{'Marketplace.TrainingType' | translate}}
                      </label>
                      <div class="display-only-div ontario-margin-bottom-24-!">{{'CreateClassroom.SelfPaced' | translate}}</div>
                    </div>
                  </div>
                }
                <!--Seating Options-->
                <div>
                  <h4 class="border-bottom">
                    {{(!hideSelectDays? 'CreateClassroom.SeatsAndPricing' : 'CreateClassroom.Pricing') | translate}}
                  </h4>
                </div>
                <div class="content">
                  @if (!hideSelectDays) {
                    <div class="field ontario-small-6 ontario-large-3">
                      <label class="required-field">{{'CreateClassroom.TotalSeats' | translate}}</label>
                      <label class="answer-text">{{classRoom.TotalSeats}}</label>
                    </div>
                  }
                  @if (!hideSelectDays) {
                    <div
                      class="field ontario-small-12 ontario-large-12 ontario-margin-top-24-! ontario-margin-bottom-32-!">
                      <input class="check" type="checkbox" [checked]="classRoom.OverEnrolmentRequestsAllowed"
                        aria-label="publish-checkbox">
                        <label class="check-label long-label">
                          {{'CreateClassroom.AllowLearnerstosendRequest' | translate}}
                        </label>
                      </div>
                    }
                    <div class="field ontario-small-12 ontario-large-6">
                      <label class="required-field">{{'CreateClassroom.Price' | translate}}</label>
                      <label class="answer-text">
                        {{classRoom.Cost == null ? ('CreateClassroom.ContactTrainingProviderForPricing' | translate) :  classRoom.Cost | currency : 'CAD'}}
                      </label>
                    </div>
                  </div>
                  <!-- Teaching staff -->
                  @if (!hideSelectDays) {
                    <div>
                      <h4 class="border-bottom">{{'CreateClassroom.TeachingStaff' | translate}}</h4>
                    </div>
                  }
                  @if (!hideSelectDays) {
                    <div class="content">
                      <div class="field  ontario-small-12 ontario-large-6">
                        <label class="required-field">{{'CreateClassroom.Instructor' | translate}}</label>
                        @for (teacher of classRoom.Instructors; track teacher) {
                          <label class="answer-text">
                            {{teacher ? teacher.Name : '--'}}
                          </label>
                        }
                        @if (classRoom.Instructors == null || classRoom.Instructors.length == 0) {
                          <label class="answer-text"
                          >--</label>
                        }
                      </div>
                      <div class="field  ontario-small-12 ontario-large-12">
                        <label class="required-field">{{'CreateClassroom.Evaluator' | translate}}</label>
                        <label class="answer-text">{{classRoom.Evaluator ? classRoom.Evaluator.Name : '--'}}</label>
                      </div>
                    </div>
                  }
                  <!-- End Teaching staff-->
                  <!--  Contact Information-->
                  <div>
                    <h4 class="border-bottom">{{'CreateClassroom.ContactInformation' | translate}}</h4>
                  </div>
                  <div class="content">
                    <div class="field ontario-small-12 ontario-large-6">
                      <label>{{'Contact.Email' | translate}}</label>
                      <label class="answer-text">{{formatUtils.replaceEmptyWithNA(classRoom.Email?.ElectronicAddressValue)}}</label>
                    </div>
                    <div class="field ontario-small-12 ontario-large-6">
                      <label>{{'Contact.Phone' | translate}}</label>
                      <label class="answer-text">
                        {{formatUtils.replaceEmptyWithNA(classRoom.PhoneNumber?.ElectronicAddressValue) | phone}}
                      </label>
                    </div>
                    <div class="field ontario-small-12 ontario-large-6">
                      <label>{{'CreateClassroom.Website' | translate}}</label>
                      <label class="answer-text">
                        @if (!classRoom.Website?.ElectronicAddressValue) {
                          <span>N/A</span>
                        }
                        @if (classRoom.Website?.ElectronicAddressValue) {
                          <a target="_blank"
                            [href]="formatUtils.formatExternalLink(classRoom.Website?.ElectronicAddressValue!)">
                            {{classRoom.Website?.ElectronicAddressValue}}
                            <img class="ext-link" src="assets/images/external-link-blue.svg" alt-text="external link" aria-label="external-link">
                          </a>
                        }
                      </label>
                    </div>
                  </div>
                  <!--  END Contact Information-->
                  <!--  Publishing options-->
                  <div>
                    <h4 class="border-bottom">{{'CreateClassroom.PublishingPreferences' | translate}}</h4>
                  </div>
                  <div class="content">
                    <div class="field ontario-small-12 ontario-large-12">
                      <input class="check" type="checkbox" [checked]="classRoom.PublishToPublic" aria-label="check-box">
                      <label class="check-label">
                        {{'CreateClassroom.publishingTrainingClassroomToPublic' | translate}}
                      </label>
                    </div>
                  </div>
                  <!--  End Publishing options-->
                </div>
              }
            </app-tab>
            @if (!enrolmentsCompleted && !isApiClass) {
              <app-tab [title]="'CreateClassroom.Enrolments' | translate" [badge]="totalConfirmedLearnerCount.toString()"
                >
                <div class="no-margins">
                  <button class="create-enrolment-button black-button"
                    [routerLink]="this.currentLang == 'en'? '/training-provider/enrolment/' + this.courseId + '/tp': '/fr/training-provider/enrolment/' + this.courseId + '/tp'">
                    {{'CreateClassroom.CreateEnrolment' | translate}}
                  </button>
                  @if (isEnrolmentCancelled && (showCancelledEnrolmentBannerObservable | async)) {
                    <div>
                      <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.PendingEnrolmentCancelledBanner').replace('{0}',bannerProgram ? bannerProgram : '').replace('{1}',datePipe.transform(bannerDate, 'MMM dd, yyyy'))">
                      </app-alert-banner>
                    </div>
                  }
                  @if (classRoom) {
                    <div class="ontario-row ontario-margin-top-24-! ontario-margin-bottom-24-! grey-box">
                      <div class="numbers-container">
                        <div class="ontario-column ontario-20-percent center-aligned right-border">
                          <div class="number-title">
                            {{'CreateClassroom.TotalSeats' | translate}}
                          </div>
                          <div class="number-content">
                            {{classRoom.TotalSeats}}
                          </div>
                        </div>
                        <div class="ontario-column ontario-20-percent center-aligned right-border">
                          <div class="number-title">
                            {{'CreateClassroom.Available' | translate}}
                          </div>
                          <div class="number-content">
                            {{classRoom.TotalSeats - totalConfirmedLearnerCount}}
                          </div>
                        </div>
                        <div class="ontario-column ontario-20-percent center-aligned right-border">
                          <div class="number-title">
                            {{'CreateClassroom.Enrolments' | translate}}
                          </div>
                          <div class="number-content">
                            {{totalConfirmedLearnerCount}}
                          </div>
                        </div>
                        <div class="ontario-column ontario-20-percent center-aligned right-border">
                          <div class="number-title">
                            {{'CreateClassroom.Requests' | translate}}
                          </div>
                          <div class="number-content">
                            {{totalPendingLearnerCount}}
                          </div>
                        </div>
                        <div class="ontario-column ontario-20-percent center-aligned">
                          <div class="number-title">
                            {{'CreateClassroom.Cancelled' | translate}}
                          </div>
                          <div class="number-content">
                            {{totalCancelledLearnerCount}}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (enrolmentsCount == 0) {
                    <div class="participants ontario-row ontario-padding-bottom-24-!">
                      <app-alert-banner bannerType="alert" [bannerText]="'ClassEnrolment.NoEnrolmentsYet' | translate"></app-alert-banner>
                    </div>
                  }
                  <div class="ontario-row">
                    <app-tabs #enroltabs (click)="checkIfPendingEnroledTabSelected()">
                      <app-tab [title]="'ClassEnrolment.Enrolled' | translate" [badge]="totalConfirmedLearnerCount>0?totalConfirmedLearnerCount.toString():''">
                        <div class="no-margins">
                          <div class="participants ontario-row ontario-padding-bottom-8-!">
                            @if (showWorkerEnrolmentForTpConfirmedBanner  && enrolmentsCountsForTpBanner > 1) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.TpEnrolmentConfirmedBannerMessage').replace('{0}',enrolmentsCountsForTpBanner)">
                              </app-alert-banner>
                            }
                            @if (showWorkerEnrolmentForTpConfirmedBanner  && enrolmentsCountsForTpBanner == 1 && enrolmentsSelfBanner) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.ConfirmSingeleSelfEnrolmentBanner')">
                              </app-alert-banner>
                            }
                            @if (showWorkerEnrolmentForTpConfirmedBanner  && enrolmentsCountsForTpBanner == 1 && !enrolmentsSelfBanner) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.ConfirmSingelePrimayContactEnrolmentBanner')">
                              </app-alert-banner>
                            }
                          </div>
                          @if (conflictingEmails && conflictingEmails.length > 0) {
                            <div
                              class="ontario-small-8 ontario-large-6 ontario-row ontario-medium-8 margin-top-02">
                              <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.LearnerInfoConflictBanner').replace('{0}',getConflictingEmailsList())">
                              </app-alert-banner>
                            </div>
                          }
                          <app-enrollment-enrolled-tab [classEnrollments]="classRoom.ConfirmedGroupEnrolments" (confirmedSelectionchanges)="refreshSelectedConfirmedRegistrationIds($event)" enrolmentStatus="enrolled"></app-enrollment-enrolled-tab>
                        </div>
                      </app-tab>
                      <app-tab [title]="'ClassEnrolment.Pending' | translate" [badge]="totalPendingLearnerCount>0?totalPendingLearnerCount.toString():''">
                        <div class="no-margins">
                          <div class="participants ontario-row ontario-padding-bottom-8-!">
                            @if (showWorkerEnrolmentForTpPendingBanner && totalPendingLearnerCount == 1 && enrolmentsSelfBanner && !enrolmentUpdateStatus) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.PendingSingeleSelfEnrolmentBanner').replace('{0}',bannerProgram).replace('{1}',datePipe.transform(bannerDate, 'MMM dd, yyyy'))">
                              </app-alert-banner>
                            }
                            @if (showWorkerEnrolmentForTpPendingBanner && totalPendingLearnerCount == 1 && !enrolmentsSelfBanner && !enrolmentUpdateStatus) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.PendingSingelePrimayContactEnrolmentBanner').replace('{0}',bannerProgram).replace('{1}',datePipe.transform(bannerDate, 'MMM dd, yyyy'))">
                              </app-alert-banner>
                            }
                            @if (showWorkerEnrolmentForTpPendingBanner && totalPendingLearnerCount > 1) {
                              <app-alert-banner
                                bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.TpEnrolmentPendingBannerMessage').replace('{0}',enrolmentsCountsForTpBanner)">
                              </app-alert-banner>
                            }
                          </div>
                          @if (enrolmentsCount != 0 && hasIncompleteLearners()) {
                            <div class="participants ontario-row ontario-padding-bottom-8-!">
                              @if (showPendingEnrolmentConfirmedBanner) {
                                <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.PendingEnrolmentConfirmedBanner')">
                                </app-alert-banner>
                              }
                            </div>
                          }
                          @if (enrolmentUpdateStatus) {
                            <div class="participants ontario-row ontario-padding-bottom-8-!">
                              <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.EnrolmentRequestUpdated')">
                              </app-alert-banner>
                            </div>
                          }
                          @if (ispendingLearnerInfoIncomplete) {
                            <div
                              class="ontario-small-8 ontario-large-6 ontario-row ontario-medium-8 margin-top-02">
                              <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.IncompleteLearner')">
                              </app-alert-banner>
                            </div>
                          }
                          @if (conflictingEmails && conflictingEmails.length > 0) {
                            <div
                              class="ontario-small-8 ontario-large-6 ontario-row ontario-medium-8 margin-top-02">
                              <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.LearnerInfoConflictBanner').replace('{0}',getConflictingEmailsList())">
                              </app-alert-banner>
                            </div>
                          }
                          @for (classEnrollment of classRoom.PendingGroupEnrolments; track classEnrollment) {
                            <app-class-enrolment-card #pendingCards [classEnrollment]="classEnrollment" (pendingSelectionchanges)="refreshSelectedPendingRegistrationIds($event)"
                            enrolmentStatus="pending"></app-class-enrolment-card>
                          }
                        </div>
                      </app-tab>
                      <app-tab [title]="'ClassEnrolment.Cancelled' | translate" [badge]="totalCancelledLearnerCount>0?totalCancelledLearnerCount.toString():''">
                        <div class="no-margins">
                          <div class="learner-banner-pos ontario-small-8 ontario-large-6 ontario-medium-8">
                            <!-- <div *ngIf="showCancelledEnrolmentBannerObservable | async" class="success-banner-margin margin-bottom-05">
                            <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.CancelledEnrolmentConfirmedBanner')">
                            </app-alert-banner>
                          </div> -->
                          @if (isCancelledLearnerInfoIncomplete) {
                            <div class="success-banner-margin">
                              <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.IncompleteLearner')">
                              </app-alert-banner>
                            </div>
                          }
                        </div>
                        @for (classEnrollment of classRoom.CancelledGroupEnrolments; track classEnrollment) {
                          <app-class-enrolment-card [classEnrollment]="classEnrollment" (pendingSelectionchanges)="refreshSelectedCancelledRegistrationIds($event)"
                          enrolmentStatus="cancelled"></app-class-enrolment-card>
                        }
                      </div>
                    </app-tab>
                  </app-tabs>
                </div>
              </div>
            </app-tab>
          }
          @if (!enrolmentsCompleted && !isApiClass) {
            <app-tab [title]="'CreateClassroom.Notifications' | translate" [Counter]="unReadCount">
              <button class="create-enrolment-button black-button" [routerLink]="this.currentLang == 'en'? '/training-provider/create-notification':'/fr/training-provider/create-notification'"
                [queryParams]="{courseId: courseId}">
                {{'CreateNotification.Create' | translate}}
              </button>
              <app-notifications-list [courseId]="courseId" (updatedUnreadCount)="this.unReadCount = $event"></app-notifications-list>
            </app-tab>
          }
          @if (enrolmentsCompleted || isApiClass) {
            <app-tab [title]="'ClassEnrolment.SubmittedRecords' | translate">
              <div class="ontario-row submitted-records-margin">
                @if (classRoom) {
                  <div class="ontario-row ontario-margin-bottom-24-! grey-box numbers-container-width">
                    <div class="numbers-container">
                      <div class="ontario-column ontario-50-percent center-aligned right-border">
                        <div class="number-title">
                          {{'CreateClassroom.TotalSeats' | translate}}
                        </div>
                        <div class="number-content">
                          {{classRoom.TotalSeats}}
                        </div>
                      </div>
                      <div class="ontario-column ontario-50-percent center-aligned right-border">
                        <div class="number-title">
                          {{'CreateClassroom.SuccessfulCompletion' | translate}}
                        </div>
                        <div class="number-content">
                          {{totalCompletedLearnerCount}}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (bannerState==1) {
                  <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.ROCDownload' | translate"></app-alert-banner>
                }
                @if (bannerState==2) {
                  <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.ROCsDownload').replace('{0}', selectedConfirmedRegistrationIds.length)"></app-alert-banner>
                }
                @if (bannerState==11) {
                  <app-alert-banner bannerType="critical" [bannerText]="'ClassEnrolment.ROCDownloadFailure' | translate"></app-alert-banner>
                }
                @if (bannerState==21) {
                  <app-alert-banner bannerType="success" [bannerText]="'ClassEnrolment.ROCSend' | translate"></app-alert-banner>
                }
                @if (bannerState==22) {
                  <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.ROCsSend').replace('{0}', selectedConfirmedRegistrationIds.length)"></app-alert-banner>
                }
                @if (bannerState==31) {
                  <app-alert-banner bannerType="critical" [bannerText]="'ClassEnrolment.ROCFailure' | translate"></app-alert-banner>
                }
                @if (showEnrolmentCompletedBanner) {
                  <div class="classroom-schedule-updated ontario-70-percent">
                    <app-alert-banner bannerType="success" [bannerText]="translateService.instant('ClassEnrolment.EnrolmentCompletionBanner').replace('{0}', totalCompletedLearnerCount)">
                    </app-alert-banner>
                  </div>
                }
                <div class="participants ontario-row ontario-padding-bottom-24-! ontario-70-percent alert-banner-margin">
                  <app-alert-banner bannerType="alert" [bannerText]="'ClassEnrolment.LearnersDetailsPrivacy' | translate"></app-alert-banner>
                </div>
                <div class="ontario-row border-bottom ontario-padding-top-24-!"></div>
                <div class="ontario-padding-top-24-!">
                  <app-enrollment-enrolled-tab [classEnrollments]="classRoom.CompletedGroupEnrolments" (confirmedSelectionchanges)="refreshSelectedConfirmedRegistrationIds($event)"
                  enrolmentStatus="SuccessfullyCompleted"></app-enrollment-enrolled-tab>
                </div>
              </div>
            </app-tab>
          }
        </app-tabs>
      </div>
    </div>
  }
  @if (hasSelectedActiveTab) {
    <div class="bottom-bar">
      <div class="full-size">
        <button id="cancel" class="grey-button" [routerLink]="this.currentLang == 'en'? '/training-provider/training-schedules':'/fr//training-provider/training-schedules'">
          {{'CreateClassroom.BackTrainingSchedules' | translate}}
        </button>
        @if (isPendingEnroledTabSelected) {
          <button id="confirm-enrolments" class="float-right blue-button" (click)="confirmEnrolment()"
            [class.disabled]="selectedPendingRegistrationIds.length==0"
            [disabled]="selectedPendingRegistrationIds.length==0">
            {{'ClassEnrolment.ConfirmEnrolments' | translate}}
          </button>
        }
        @if (isConfirmedEnroledTabSelected && showIssueRecordOfCompletionButton) {
          <button id="submit-enrolments" class="float-right blue-button"
            [class.disabled]="!checkClassLastOrCompleteDate() || isLearnerDetailsIncomplete"
            [disabled]="!checkClassLastOrCompleteDate() || isLearnerDetailsIncomplete"
            (click)="submitRecordsOfCompletion()">
            {{'ClassEnrolment.SubmitForCompletion' | translate}}
          </button>
        }
        @if (isCancelledEnroledTabSelected || isConfirmedEnroledTabSelected) {
          <button id="move-pending" class="float-right blue-button" style="margin-right: 30px !important;" (click)="moveToPending()"
            [class.disabled]="moveToPendingDisabled()" [disabled]="moveToPendingDisabled()">
            {{'ClassEnrolment.MoveToPending' | translate}}
          </button>
        }
        @if (!enrolmentTabSelected && !enrolmentsCompleted && isClassRoomActive && !isApiClass) {
          <button id="preview-class" class="float-right blue-button"
            [routerLink]="[this.currentLang == 'en'? '/training-provider/edit-classroom':'/fr//training-provider/edit-classroom',courseId]">
            {{'CreateClassroom.EditClassroom' | translate}}
          </button>
        }
        @if (selectSubmittedRecordsTab && showIssueRecordOfCompletionButton) {
          <button (click)="shareRoC()" class="float-right blue-button"
            [disabled]="selectedConfirmedRegistrationIds.length==0">
            {{'Worker.Share' | translate}}
          </button>
        }
        @if (selectSubmittedRecordsTab &&  showIssueRecordOfCompletionButton) {
          <button (click)="downloadRoC()" class="float-right black-button" style="margin-right: 30px !important;"
            [disabled]="selectedConfirmedRegistrationIds.length==0">
            {{'ClassEnrolment.Download' | translate}}
          </button>
        }
      </div>
    </div>
  }
